var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"responsive-img",attrs:{"alt":_vm.alt,"src":_vm.path}})
}
var staticRenderFns = []

export { render, staticRenderFns }